declare const __ucCmp: any;

const cloudflareId = "xQ7R_MtouldLmR";
const googleMapsId = "S1pcEj_jZX";
const youtubeId = "BJz7qNsdj-7";
const yumpuId = "6LdBYXdAl";
const yumpuPlaceholder = `yumpu${yumpuId}`;

let recaptchaAllowed = false;
let cloudflareAllowed = false;

const createPlaceholderHtml = (templateId: string, className: string = null): string => {
	return `
	<div class="ucConsent contentCtrls ${className ?? templateId}">
		<p class="heading">Wir benötigen Ihre Zustimmung, um einen Service zu laden!</p>
		<p>
			Wir verwenden an dieser Stelle einen Service, um Inhalte einzubetten. 
			Dieser Service kann Daten zu Ihren Aktivitäten sammeln. Bitte lesen Sie die Details durch und stimmen Sie der Nutzung des Service zu, um diese Inhalte anzuzeigen.
		</p>
		<a class="ucAgree button button__cta button--red" onclick="__ucCmp.updateServicesConsents([{id: '${templateId}', consent: true}]); __ucCmp.saveConsents(); return false;"><span class="txt">Zustimmen</span></a>
		<a class="moreInfo link" onclick="__ucCmp.showServiceDetails('${templateId}'); return false;">Mehr Informationen</a>
	</div>`;
};

const checkForYouTubeIframe = (iframe: HTMLIFrameElement, youTubeAllowed: boolean): void => {
	const ucSrc = iframe.getAttribute("uc-src");
	if (ucSrc && ucSrc.indexOf("youtube") !== -1) {
		if (youTubeAllowed) {
			iframe.setAttribute("src", iframe.getAttribute("uc-src"));
		} else {
			iframe.insertAdjacentHTML("afterend", createPlaceholderHtml(youtubeId));
			iframe.hidden = true;
		}
	}
};

const checkForGoogleMapsIframe = (iframe: HTMLIFrameElement, googleMapsAllowed: boolean): void => {
	const ucSrc = iframe.getAttribute("uc-src");
	if (ucSrc && ucSrc.indexOf("google.com/maps") !== -1) {
		if (googleMapsAllowed) {
			iframe.setAttribute("src", iframe.getAttribute("uc-src"));
		} else {
			iframe.insertAdjacentHTML("afterend", createPlaceholderHtml(googleMapsId));
			iframe.hidden = true;
		}
	}
};

const checkForYumpuIframe = (iframe: HTMLIFrameElement, yumpuAllowed: boolean): void => {
	const ucSrc = iframe.getAttribute("uc-src");
	if (ucSrc && (ucSrc.indexOf("yumpu") !== -1 || ucSrc.indexOf("neuheiten.beck") !== -1)) {
		if (yumpuAllowed) {
			iframe.setAttribute("src", iframe.getAttribute("uc-src"));
		} else {
			iframe.insertAdjacentHTML("afterend", createPlaceholderHtml(yumpuId, yumpuPlaceholder));
			iframe.hidden = true;
		}
	}
};

export const checkForCloudflare = (lazy: boolean = false, containerClass: string = null) => {
	let className = lazy ? ".cf-turnstile-lazy" : ".cf-turnstile-uc";

	if (containerClass) {
		className = containerClass;
	}

	const container = document.querySelectorAll<HTMLElement>(className);

	if (!cloudflareAllowed) {
		container.forEach((item) => {
			item.innerHTML = "";
			item.innerHTML = createPlaceholderHtml(cloudflareId);
		});
	} else {
		try {
			showCloudflare();
		} catch (err) {}
	}
};

const showCloudflare = (lazy: boolean = false): void => {
	let selector = lazy ? ".cf-turnstile-lazy" : ".cf-turnstile-uc";

	document.querySelectorAll(`.${cloudflareId}`).forEach((el) => el.remove());

	const elements = document.querySelectorAll<HTMLElement>(selector);

	if (elements.length === 0) {
		return;
	}

	// Wait for window.turnstile to be available
	if (typeof window.turnstile === "undefined") {
		console.log("Waiting for Cloudflare Turnstile to be available...");

		setTimeout(() => showCloudflare(lazy), 100);
		return;
	}

	try {
		const cloudflareFormId = window.sessionStorage.getItem("cloudflareFormId");
		if (cloudflareFormId) {
			selector = cloudflareFormId;
		}

		elements.forEach((el) => {
			const sitekey = el.dataset.sitekey;
			if (!sitekey || el.dataset.widget) return;

			const widgetId = window.turnstile.render(el, {
				sitekey,
				callback: null
			});

			el.dataset.widget = String(widgetId);
		});

		window.sessionStorage.removeItem("cloudflareFormId");
	} catch (err) {
		console.error("Error initializing Turnstile:", err);
	}
};

const showGoogleMapsIframe = (iframe: HTMLElement): void => {
	const ucSrc = iframe.getAttribute("uc-src");
	if (ucSrc && ucSrc.indexOf("google.com/maps") !== -1) {
		iframe.setAttribute("src", iframe.getAttribute("uc-src"));
		iframe.hidden = false;
		document.querySelector(`.${googleMapsId}`)?.remove();
	}
};

const showYoutubeIframe = (iframe: HTMLElement): void => {
	const ucSrc = iframe.getAttribute("uc-src");
	if (ucSrc && ucSrc.indexOf("youtube") !== -1) {
		iframe.setAttribute("src", iframe.getAttribute("uc-src"));
		iframe.hidden = false;
		document.querySelector(`.${youtubeId}`)?.remove();
	}
};

const showYumpuIframe = (iframe: HTMLElement): void => {
	const ucSrc = iframe.getAttribute("uc-src");
	if (ucSrc && (ucSrc.indexOf("yumpu") !== -1 || ucSrc.indexOf("neuheiten.beck") !== -1)) {
		iframe.setAttribute("src", iframe.getAttribute("uc-src"));
		iframe.hidden = false;
		document.querySelector(`.${yumpuPlaceholder}`)?.remove();
	}
};

const addEventListeners = (): void => {
	window.addEventListener("onConsentChanged", function(e: any) {
		const iframes = document.querySelectorAll("iframe");

		if (e.detail.event === "consent_status" && e.detail["Google Maps"]) {
			iframes.forEach(function(iframe) {
				showGoogleMapsIframe(iframe);
			});
		}
		if (e.detail.event === "consent_status" && e.detail["YouTube Video"]) {
			iframes.forEach(function(iframe) {
				showYoutubeIframe(iframe);
			});
		}
		if (e.detail.event === "consent_status" && e.detail.yumpu) {
			iframes.forEach(function(iframe) {
				showYumpuIframe(iframe);
			});
		}

		if (e.detail.event === "consent_status" && e.detail["Cloudflare Turnstile"] !== undefined) {
			cloudflareAllowed = e.detail["Cloudflare Turnstile"];
			checkForCloudflare();
		}
	});
};

export const initUserCentrics = async () => {
	addEventListeners();

	if ((window as { [key: string]: any }).__ucCmp !== undefined && (await __ucCmp.isInitialized())) {
		const details = await __ucCmp.getConsentDetails();
		const youTubeAllowed = details.services[youtubeId].consent.given;
		const googleMapsAllowed = details.services[googleMapsId].consent.given;
		const yumpuAllowed = details.services[yumpuId].consent.given;
		const iframes = document.querySelectorAll("iframe");
		iframes.forEach(function(iframe) {
			checkForYouTubeIframe(iframe, youTubeAllowed);
			checkForGoogleMapsIframe(iframe, googleMapsAllowed);
			checkForYumpuIframe(iframe, yumpuAllowed);
		});
	} else {
		setTimeout(initUserCentrics, 100);
	}
};

export const IsCloudflareAllowed = (): boolean => {
	return cloudflareAllowed;
};

export const initCloudflare = async () => {
	if ((window as { [key: string]: any }).__ucCmp !== undefined && (await __ucCmp.isInitialized())) {
		const details = await __ucCmp.getConsentDetails();
		cloudflareAllowed = details.services[cloudflareId].consent.given;
		checkForCloudflare();
	} else {
		setTimeout(initCloudflare, 100);
	}
};

document.addEventListener("DOMContentLoaded", () => {
	initUserCentrics();
});
